// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { FieldValueResponse } from './field-value-response';

/** See com.rev360.pms.api.controller.encounter.dynamic.form.FieldValueDateResponse */
/* istanbul ignore next */
@GandalfModel
export class FieldValueDateResponse extends FieldValueResponse {

	@GandalfProperty({ designType: Number })
	fieldId!: number | null;

	@GandalfProperty({ designType: Date })
	value!: Date | null;

}
